export default __webpack_public_path__ + "static/media/logo-black.0021f0fc.svg";